<template>
    <b-container fluid class="mt--7">
        <view-item
            v-if="!!template"
            :template_id="template.id"
            @success="alertSuccess"
            @delete-item="deleteType"
            @cancel="template = null"
        ></view-item>

        <list-items
            v-else
            title="Templates"
            @show-item="evt => showTemplate(evt)"
            ref="table"
        >
            <b-row v-if="hasPermissionCreate">
                <b-col offset="8" class="text-right">
                    <b-button
                        size="sm"
                        variant="primary"
                        v-if="hasPermissionCreate"
                        @click="() => showTemplate()"
                        >Add Template</b-button
                    >
                </b-col>
            </b-row>
        </list-items>
    </b-container>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

import ListItems from './ListItems'
import ViewItem from './ViewItem'

export default {
    name: 'OrderTemplates',
    components: {
        ListItems,
        ViewItem,
    },
    mixins: [popupMixins, utilityMixins, permissionsMixins],
    data: () => {
        return {
            componentName:'Activity Template',
            template: null,
        }
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('orderCategory/fetchAll')
        this.$store.dispatch('transactionType/fetchAll')
    },
    mounted() {
        this.doSearch()
    },
    computed: {
        templates() {
            const templates = this.$store.state.orderTemplate.templates
            console.log('templates', templates)
            return templates
        },
        categories() {
            const categories = this.$store.state.orderCategory.categories
            console.log('categories', categories)
            return categories
        },
        types() {
            const items = this.$store.state.orderType.items
            console.log('items', items)
            return items
        },
        user_permissions() {
            return this.$store.getters.user_permissions
        },
    },

    methods: {
        doSearch() {
            this.$store.dispatch('orderTemplate/fetchAll')
        },

        showTemplate(id) {
            if (id) {
                this.template = this.templates.find(x => x.id === id)
                this.$store.dispatch('orderTemplate/fetchById', id)
            } else {
                const newItem = {
                    id: null,
                    order_category_id: null,
                    name: null,
                    description: null,
                    order_type_id: null,
                    secondary_order_type_id: null,
                    items: [],
                }
                this.template = newItem
                this.$store.commit('orderTemplate/set_template', newItem)
            }
        },

        alertSuccess(action, name) {

            this.genericToast(this.componentName, (action.charAt(0).toUpperCase()+action.slice(1)+'d'),'success', `"${name}" ${action.toLowerCase()}d successfully`)

            //this.doToast('Success', message, 'success')
            this.template = null
            this.doSearch()
        },
    },
}
</script>
<style></style>
